// src/widgets/PerceptionWidget.tsx

import { ResponseEventWidget, ResponseEventItem, ResponseEventUpdate } from './ResponseEventWidget';
import { RealtimeEvent } from '../utils/events.js';
import { MarkdownContainer } from '../components/MarkdownContainer';
import { OverviewContent } from '../components/OverviewContent';
import { AgentDescription } from '../types/AgentDescription';
import { OverviewObject } from '../types/DataObject';
import '../components/OverviewContent.scss';

interface PerceptionWidgetProps {

}

export const PerceptionWidget: React.FC<PerceptionWidgetProps> = ({

}) => {

  const itemContent = (eventItem: ResponseEventItem) => {
    if (eventItem.output.recipient === 'overview') {
      const overview = eventItem.output.content as OverviewObject;
      return (
        <div className="overview-content-container">
          <OverviewContent
            overview={overview}
            inProgress={false}
          />
        </div>
      );
    }
    return (
      <MarkdownContainer
        content={eventItem.output.content}
        type="xml"
      />
    )
  }

  const speakerName = (eventItem: ResponseEventItem) => {
    return AgentDescription(eventItem.output.sender).name
  }

  const filterCondition = (eventItem: ResponseEventItem, selectedModule: string, selectedFilters: (string | undefined)[]) => {
    if (selectedModule != '' && !eventItem.output.recipient.includes(selectedModule)) {
      return false;
    }
    if (selectedFilters.includes(eventItem.output.sender)) {
      return false;
    }
    return true
  }

  const eventUpdate = (realtimeEvent: RealtimeEvent, output: ResponseEventUpdate) => {

    const itemOutput = realtimeEvent.event.item.output[0]

    if (output.metadata?.useSystemTwo === true) {
      output.modules.push('overview')
    }

    output.modules.push(itemOutput.recipient)
    output.filters.push({
      label: AgentDescription(itemOutput.sender).name,
      value: itemOutput.sender
    })

    const item: ResponseEventItem = {
      responseId: realtimeEvent.event.response_id,
      id: realtimeEvent.event.item.id,
      role: ['human_proxy_auto', 'team_assistant'].includes(itemOutput.sender) ? 'user' : 'assistant',
      type: 'function_call_output',
      output: itemOutput
    }

    output.items.push(item)
  }


  return (
    <ResponseEventWidget
      eventType='perception'
      storageField='fabric_perception_agent_filters'
      itemContent={itemContent}
      speakerName={speakerName}
      filterCondition={filterCondition}
      eventUpdate={eventUpdate}
    />
  )
};